import AggregateRating from './AggregateRating'

export default AggregateRating
